import { render, staticRenderFns } from "./ChangePreRegSubject.vue?vue&type=template&id=4ea4cd58"
import script from "./ChangePreRegSubject.vue?vue&type=script&lang=js"
export * from "./ChangePreRegSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports